import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { GET_CUSTOM_FIELDS } from 'src/app/project/modules/custom-fields/custom-fields.store';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';
import {
  TAdvancedFilterPercentage,
  TAdvancedFilterSingle,
  TFilterPercentageOptions,
} from '../../../../models/advanced-filter.model';
import {
  IS_EMPTY_NUMERICAL,
  IS_NOT_EMPTY_NUMERICAL,
  percentageOperatorWithEqualToOptions,
} from '../../../../utils/advanced-filter-operator.utils';

@Component({
  selector: 'pp-advanced-filter-percentage',
  templateUrl: './advanced-filter-percentage.component.html',
  styleUrls: ['./advanced-filter-percentage.component.scss'],
  standalone: false,
})
export class AdvancedFilterPercentageComponent {
  @Input() ppFilter: TAdvancedFilterSingle;
  @Output() ppFilterChange = new EventEmitter<TAdvancedFilterSingle>();

  value: number;
  option: TFilterPercentageOptions;
  filter: TAdvancedFilterPercentage;
  showCommas: boolean;

  advancedFilterPercentageOptions: TSelectOption[];
  EAdvancedFilterOptions = EAdvancedFilterOptions;

  ngOnInit() {
    this.advancedFilterPercentageOptions = percentageOperatorWithEqualToOptions;
  }
  ngOnChanges(): void {
    this.filter = this.ppFilter as TAdvancedFilterPercentage;

    this.value = this.filter.value;
    this.option = this.filter.option;

    const field = GET_CUSTOM_FIELDS()[this.filter.id];
    this.showCommas = field.showCommas;
  }

  changeFieldCondition(newCondition: TSelectOption): void {
    this.ppFilter.option = newCondition.value as TFilterPercentageOptions;
    this.option = newCondition.value as TFilterPercentageOptions;

    this.ppFilter.operator = newCondition.operator;

    if (
      this.ppFilter.option === EAdvancedFilterOptions.IS_EMPTY ||
      this.ppFilter.option === EAdvancedFilterOptions.IS_NOT_EMPTY
    ) {
      this.ppFilter.value = newCondition.data;
    }

    this.applyChanges();
  }

  applyChanges(): void {
    if (Array.isArray(this.filter.value) && this.filter.value?.every((v) => v === null)) {
      this.ppFilter.value = null;
    }

    if (
      this.ppFilter.option === EAdvancedFilterOptions.IS_EMPTY ||
      this.ppFilter.option === EAdvancedFilterOptions.IS_NOT_EMPTY
    ) {
      this.ppFilter.value = (this.ppFilter.option === EAdvancedFilterOptions.IS_EMPTY
        ? IS_EMPTY_NUMERICAL.data
        : IS_NOT_EMPTY_NUMERICAL.data) as unknown as number[];
    }

    this.ppFilterChange.emit(this.ppFilter);
  }

  changeFieldValue(value: number): void {
    this.ppFilter.value = value;
    this.applyChanges();
  }
}
